import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getAiChats = {
  name: "getAiChats" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({ chatHistory: MessageSchema.array() }),
};
